import { memo } from 'react';
import { createPortal } from 'react-dom';
import Confetti from 'react-confetti';
import { useWindowSize } from 'usehooks-ts';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { RedesignGiveawayRedeemModal } from 'root/src/client/v2/_pages/creator/redesign/RedesignGiveawayRedeemModal';
// Redesign rewrite of the legacy `GiveawayWonModal`. Celebratory step shown when the viewer wins this
// creator's giveaway; "Select your reward" opens the redesign redeem modal.
export const RedesignGiveawayWonModal = memo(({ creatorUserId, creatorMnemonicId }) => {
    const { show } = useRedesignModal();
    const { width, height } = useWindowSize();
    return (<>
			{typeof document !== 'undefined' && createPortal(<div className="pointer-events-none fixed inset-0 z-[1102]">
					<Confetti width={width} height={height} recycle={false} numberOfPieces={250}/>
				</div>, document.body)}
			<RedesignModalShell className="sm:max-w-md">
				<div className="flex w-full flex-col items-center gap-4 text-center">
					<div className="flex h-16 w-16 items-center justify-center rounded-full border border-solid border-neon-amber/30 bg-neon-amber/10">
						<EmojiEventsIcon sx={{ fontSize: 32 }} className="text-neon-amber"/>
					</div>
					<h2 className="font-display text-2xl font-bold text-gradient-brand">Congratulations</h2>
					<p className="text-sm text-muted-foreground">You won the giveaway. Pick your reward to claim it.</p>
					<Button type="button" variant="brand" onClick={() => show(<RedesignGiveawayRedeemModal creatorUserId={creatorUserId} creatorMnemonicId={creatorMnemonicId}/>)} className="w-full rounded-xl text-sm font-semibold">
						Select your reward
					</Button>
				</div>
			</RedesignModalShell>
		</>);
});
